import { InsurerLogos } from "../../../components/Questionnaire/Amble/InsurerLogos";
import {
  BUSINESS_SHOP_INSURERS,
  COMMERCIAL_LANDLORD_INSURERS,
  CONTRACTORS_COMBINED_INSURERS,
  LANDLORD_INSURERS,
  PROFESSIONAL_INSURERS,
} from "../../../components/Questionnaire/Amble/InsurerLogos/insurerData";
import type { AmbleContent } from "..";

/**
 * Insurer logo ambles for UK verticals.
 * Keys match the preambleName values from the questions API (e.g. "landlord_insurer_logos").
 */
export const insurerLogosAmbles: Record<string, AmbleContent> = {
  landlord_insurer_logos: <InsurerLogos insurers={LANDLORD_INSURERS} />,
  shop_insurer_logos: <InsurerLogos insurers={BUSINESS_SHOP_INSURERS} />,
  business_insurer_logos: <InsurerLogos insurers={BUSINESS_SHOP_INSURERS} />,
  professional_insurer_logos: <InsurerLogos insurers={PROFESSIONAL_INSURERS} />,
  commercial_landlord_insurer_logos: (
    <InsurerLogos insurers={COMMERCIAL_LANDLORD_INSURERS} />
  ),
  contractors_combined_insurer_logos: (
    <InsurerLogos insurers={CONTRACTORS_COMBINED_INSURERS} />
  ),
};
